<template>
    <div>
        <PageTitle title="Política de privacidad"/>
        <FirstBanner/>
        <section class="padding-vertical-content">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <p v-html="manager.privacidad"></p>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    import PageTitle from '@/components/frontend/shared/PageTitle';
    import FirstBanner from '@/components/frontend/shared/FirstBanner';
    import { useHead } from '@/composables/common/seo/useHead';

    export default {
        data() {
            return {
            }
        },
        created() {
            useHead('Privacidad');
        },
        computed: {
            configuracion() {
                return this.$store.getters.getConfig
            },
            manager() {
                return this.$store.getters.getFooter;
            },
            teatro() {
                return this.$store.getters.getTeatro;
            }
        },
        components: {
            PageTitle, FirstBanner
        }
    }
</script>
